export default typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {}



// WEBPACK FOOTER //
// ../../../node_modules/rollup-plugin-node-globals/src/global.js